import { useQuotationStore } from '../stores/quotation.store'

export function useQuotation() {
  const quotations = useQuotationStore((state) => state.quotations)

  const quotation = useQuotationStore((state) => state.quotation)

  const meta = useQuotationStore((state) => state.meta)

  const createQuotation = useQuotationStore((state) => state.createQuotation)

  const getQuotations = useQuotationStore((state) => state.getQuotations)

  const getQuotationById = useQuotationStore((state) => state.getQuotationById)

  const updateQuotation = useQuotationStore((state) => state.updateQuotation)

  const deleteQuotation = useQuotationStore((state) => state.deleteQuotation)

  return {
    quotations,
    quotation,
    meta,
    createQuotation,
    getQuotations,
    getQuotationById,
    updateQuotation,
    deleteQuotation,
  }
}
